module.exports = __webpack_public_path__ + "img/silvia-moreno-garcia.aab2ef0d.png";